module.exports = __webpack_public_path__ + "img/vision.1026c34e.svg";